import { useNavigate } from "react-router-dom";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";
import { useState } from "react";

const ManageSubadmin = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debounceSearchTerm, setDebounceSearchTerm] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Manage Sub-Admin</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Sub-Admin
        </p>
      </div>

      <div className="cards">
        <SubadminListTopbar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setDebounceSearchTerm={setDebounceSearchTerm}
        />
        <SubadminList search={debounceSearchTerm} />
      </div>
    </>
  );
};

export default ManageSubadmin;
